<template>
  <button v-tooltip="{ title: tooltip }" class="icon__button" @click="click">
    <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon" />
  </button>
</template>

<script>
export default {
  name: "IconButtonComponent",
  props: {
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["buttonClick"],
  methods: {
    click() {
      this.$emit("buttonClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  &__button {
    border: none;
    background-color: inherit;
    font-size: 16px;
    color: $black;
  }
}
</style>
